import React, { HTMLAttributes } from 'react';

interface ContentTagPropsBase {
  // Add base props here
  variant: 'light' | 'dark';
}

type ContentTagProps = ContentTagPropsBase & HTMLAttributes<HTMLDivElement>;

export function ContentTag(props: ContentTagProps) {
  const { className: propClasses, style: propStyles, variant, ...rest } = props;

  const classes = ['px-3 py-1 rounded-lg text-sm'];
  let style: React.CSSProperties = {};

  if (variant === 'light') {
    classes.push('bg-highlight');
  } else if (variant === 'dark') {
    classes.push('text-white');
    style.backgroundColor = 'rgba(0,0,0,0.6)';
  }

  if (propClasses) classes.push(propClasses);
  if (propStyles) style = { ...style, ...propStyles };

  classes.push('go-content-tag');

  return <div {...rest} className={classes.join(' ')} style={style}></div>;
}
